import React, { useEffect, useState } from "react";
import { Table, Row, Col, Space, Typography, Tag, Switch } from "antd";
import { EyeOutlined, ApiOutlined, CheckCircleOutlined } from "@ant-design/icons";
import columns from "@staticData/admin/adminUsersListTableColumns";
import DeactivateUser from "@general/deactivateUser";
import { Link } from "react-router-dom";
import ActivateUser from "@general/activateUser";
import moment from "moment-jalaali";
function AdminUsersListTable({
  data,
  onPageChange,
  currentPage,
  onSort,
  loading,
  onOpenDrawer,
  onUserDataUpdate,
}) {
  const [tableData, setTableData] = useState([]);
  const [areDiactivatedUsersHidden, setAreDeactivatedUsersHidden] = useState(false);
  const { getUsersCount: count, getUsers: users } = data;

  const { Text } = Typography;

  useEffect(() => {
    const initialTableData = [];
    users.map((user) => {
      const {
        id,
        createdAt,
        name,
        nationalIdCardNo,
        mobile,
        deactivatedAt,
        userRole,
        confirmStatus,
      } = user;

      initialTableData.push({
        key: id,
        nationalIdCardNo,
        name: deactivatedAt ? <Tag color="#cccccc">{name}</Tag> : name,
        deactivatedAt,
        createdAt: moment(createdAt).format("jYYYY/jMM/jDD"),
        mobile,
        userRole: [userRole],
        confirmStatus: [confirmStatus],
        details: (
          <Space>
            <a onClick={() => onOpenDrawer(id, name)}>
              <EyeOutlined />
            </a>
            |
            {deactivatedAt ? (
              <ActivateUser
                id={id}
                name={name}
                onActivateUser={onUserDataUpdate}
              >
                <a>
                <CheckCircleOutlined />
                </a>
              </ActivateUser>
            ) : (
              <DeactivateUser
                id={id}
                name={name}
                onDeactivateUser={onUserDataUpdate}
              >
                <a>
                  <ApiOutlined />
                </a>
              </DeactivateUser>
            )} |
            <Link to={`/admin-transactions/${id}`}>تراکنش ها</Link>|{" "}
            <Link to={`/admin-purchases/${id}`}>خدمات</Link>
          </Space>
        ),
      });
    });
    setTableData(initialTableData);
  }, [users]);

  const onChange = (pagination, filters, sorter, extra) => {
    if (extra.action === "sort") {
      onSort(sorter);
    }
    if (extra.action === "paginate") {
      onPageChange(pagination.current);
    }
  };


  return (
    <>
      <Row>
        <Col span={24}>
        <Space align>
        <p>نمایش کاربران غیرفعال شده: </p>
        <Switch checked={areDiactivatedUsersHidden} onChange={() => setAreDeactivatedUsersHidden(!areDiactivatedUsersHidden)} />
      </Space>
          <Table
            columns={columns}
            dataSource={
              areDiactivatedUsersHidden ? tableData : tableData.filter(user => user.deactivatedAt === null)
            }
            pagination={{
              total: count,
              current: currentPage,
              showSizeChanger: false,
            }}
            onChange={onChange}
            loading={loading}
            scroll={{ x: 1000 }}
          />
        </Col>
      </Row>
    </>
  );
}

export default AdminUsersListTable;
